import { DataBean } from "../DataBean";

export class TypeConstantsForAction extends DataBean {


    public async getPhysicalTakingTypeConstantsForAction(ID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPhysicalTakingTypeConstantsForAction_Number", [ID]);
    }

 
}